<!-- 车场通道信息变更上报 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "dataList":[
                    {
                        "chargeTypeSeq":85,
                        "isDefault":1,
                        "chargeTypeName":"默认计费组",
                        "carType":1,
                        "operateMode":1,
                        "reportChargeStandardList":[
                            {
                                "standardName":"8+8",
                                "carType":20,
                                "enable":1,
                                "workDayMode":2,
                                "remark":"",
                                "carTypeDesc":"两轮车",
                                "reportChargeStandardDetailVOList":[
                                    {
                                        "standardDetailSeq":2170,
                                        "chargeType":2,
                                        "startTime":"00:00:00",
                                        "endTime":"23:59:59"
                                    }
                                ],
                                "standardSeq":4
                            }
                        ],
                        "updateTime":"20230704181202",
                        "WorkDay":1
                    }
                ],
                "parkCode":"2KKN885S"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动计费规则信息变更上报到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportBindingFeeRules",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'dataList', info2: '是', info3: 'JSONArray', info4: '变更计费规则列表' },
                        ]
                },{
                    titleName: 'dataList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'chargeTypeSeq', info2: '是', info3: 'Integer', info4: '收费组序列号' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '操作时间 yyyyMMddHHmmss' },
                        { info1: 'isDefault', info2: '是', info3: 'Integer', info4: ' 0非默认计费规则，1默认计费规则' },
                        { info1: 'chargeTypeName', info2: '是', info3: 'String', info4: '收费组名称' },
                        { info1: 'operateMode', info2: '是', info3: 'Integer', info4: '数据状态 0新增，1更新，2删除' },
                        { info1: 'carType', info2: '是', info3: 'Integer', info4: '是否区分车辆类型 0：不区分 1:区分' },
                        { info1: 'WorkDay', info2: '是', info3: 'Integer', info4: '是否区分节假日 0：不区分 1:区分' },
                        { info1: 'reportChargeStandardList', info2: '是', info3: 'JSONArray', info4: '收费组里的具体收费规则' },
                        ]

                },{
                    titleName: 'reportChargeStandardList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'standardName', info2: '是', info3: 'String', info4: '计费规则名称' },
                        { info1: 'carType', info2: '是', info3: 'Integer', info4: '车辆类型' },
                        { info1: 'enable', info2: '是', info3: 'Integer', info4: '启用禁用（0禁用，1启用）' },
                        { info1: 'workDayMode', info2: '是', info3: 'Integer', info4: '节假日模式 0不区分 1工作日 2节假日' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '收费规则描述' },
                        { info1: 'carTypeDesc', info2: '是', info3: 'String', info4: '车辆类型描述' },
                        { info1: 'standardSeq', info2: '是', info3: 'Integer', info4: '计费规则唯一标识' },
                        { info1: 'extend', info2: '否', info3: 'String', info4: '拓展' },
                        { info1: 'reportChargeStandardDetailVOList', info2: '是', info3: 'JSONArray', info4: '收费规则详情' },
                        ]

                },{
                    titleName: 'reportChargeStandardDetailVOList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'standardDetailSeq', info2: '否', info3: 'String', info4: '收费明细自增序列' },
                        { info1: 'chargeType', info2: '否', info3: 'Integer', info4: '收费方式，1单价/按时，2定额/阶梯，3计次/按次' },
                        { info1: 'startTime', info2: '否', info3: 'String', info4: '起始时间 HH:mm:ss' },
                        { info1: 'endTime', info2: '否', info3: 'String', info4: '结束时间 HH:mm:ss' },    
                    ]

                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportBindingFeeRules.vue